
export class QuidelOrthoTroponinResult {

    static Status = Object.freeze({ aboveCutoff: 1, highRisk: 2, normal: 3 });

    statusTitle(status) {
        switch (status) {
            case QuidelOrthoTroponinResult.Status.aboveCutoff:
                return 'Above cut-off';
            case QuidelOrthoTroponinResult.Status.highRisk:
                return 'High Risk';
            case QuidelOrthoTroponinResult.Status.normal:
                return 'Normal';
        }
    }

    static lessThanThreshold = '<0.05'

    constructor(resultString) {
        if (resultString == QuidelOrthoTroponinResult.lessThanThreshold) {
            this.numberValue = 0;
        } else {
            let value = parseFloat(resultString);
            if (value < 0.05) {
                this.numberValue = 0;
            } else {
                this.numberValue = value;
            }
        }
    }

    static newTroponinResult(value) {
        if (value != null && value != undefined && value.toString().length > 0 && (value === QuidelOrthoTroponinResult.lessThanThreshold || (!isNaN(parseFloat(value)) && (parseFloat(value) != null) ))) {
            return new QuidelOrthoTroponinResult(value.toString());
        }
        return null;
    }

    get string() {
        if (this.numberValue < 0.05) {
            return QuidelOrthoTroponinResult.lessThanThreshold;
        } else if (this.numberValue != undefined) {
            return this.numberValue.toString();
        }
    }

    set numberValue(value) {
        this._numberValue = value;
    }

    get numberValue() {
        return this._numberValue;
    }

    get doubleValue() {
        if (this.numberValue < 0.05) {
            return 0;
        }
        return this.numberValue;
    }

    getStatus() {
        if (this.doubleValue > 30) {
            return QuidelOrthoTroponinResult.Status.aboveCutoff;
        } else {
            if (this.doubleValue > 0.05) {
                return QuidelOrthoTroponinResult.Status.highRisk;
            } else {
                return QuidelOrthoTroponinResult.Status.normal;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/forms/edChestPain01/Custom Types/QuidelOrthoTroponin.js